import { Redirect, Route, Switch } from "react-router-dom";
import { MyActionsPage } from "pages/MyActionsPage/MyActionsPage";
import { UsersProvider } from "contexts/UsersContext";

export const MyActionsRoute = (): JSX.Element => {
  return (
    <Switch>
      <Route exact path="/pages/my-actions">
        <UsersProvider>
          <MyActionsPage />
        </UsersProvider>
      </Route>

      {/* Redirect to the closest exact path above when an incorrect url is entered*/}
      <Redirect to="/pages/my-actions" from="/pages/my-actions" />
      <Redirect to="/pages" />
    </Switch>
  );
};
